export const STORAGE_LANGUAGE_NAME = "lang";
export const STORAGE_AUTH_TOKEN = "authToken";
export const STORAGE_RECOVERY_TOKEN = "recoveryToken";
export const STORAGE_CLICK_ID = "clickId";
export const STORAGE_CURRENCY_FROM_LINK = "currencyFromLink";
export const STORAGE_UTM_MEDIUM = "utmMedium";
export const STORAGE_UTM_SOURCE = "utmSource";
export const STORAGE_UTM_CAMPAIGN = "utmCampaign";
export const STORAGE_USER_COUNTRY = "userCountry";
export const STORAGE_USER_IP = "userIP";
export const STORAGE_SIDE_MENU = "sideMenu";
export const BLOOMREACH_USER_TOKEN = "bloomreachUserToken";

export enum SearchFields {
  CURRENCY = "search",
  LANGUAGE = "language-search",
  PROVIDER = "provider-search",
  BANKS = "banks-search",
}

export const APP_VERSION = "v1.13.06";
